'use client'
import { StoryblokComponent, storyblokEditable } from '@storyblok/react'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { type ExpectedBlockType, type GridColumnsField, type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { wrapper, column } from './GridBlock.css'
import type { ImageTextBlockProps } from './ImageTextBlock'

type ColumnBloks = ExpectedBlockType<ImageTextBlockProps>

type GridBlockProps = SbBaseBlockProps<{
  title?: string
  columns: ColumnBloks
  layout?: GridColumnsField
}>

export function GridBlock({ blok, nested }: GridBlockProps) {
  // Define a grid with 2-4 columns based on no. of items
  const columns = Math.min(4, Math.max(2, blok.columns.length))

  return (
    <GridLayout.Root {...storyblokEditable(blok)} nested={nested}>
      <GridLayout.Content width={blok.layout?.widths ?? { _: '1' }} align="center">
        <div className={wrapper}>
          {blok.columns.map((nestedBlock) => (
            <div key={nestedBlock._uid} className={column} data-columns={columns}>
              <StoryblokComponent blok={nestedBlock} nested={true} />
            </div>
          ))}
        </div>
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
GridBlock.blockName = 'grid'
